import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface AppState {
    downloads: any[]
}

@Injectable({
    providedIn: 'root'
})
export class StoreService {

    private initialState: AppState = {
        downloads: []
    };
    private state$ = new BehaviorSubject<AppState>(this.initialState);

    stateObservable$ = this.state$.asObservable();

    get state(): AppState {
        return this.state$.value;
    }

    updateState(newPartialState: Partial<AppState>) {
        const currentState = this.state$.getValue();
        const updatedState = { ...currentState, ...newPartialState };
        this.state$.next(updatedState);
    }

    reset() {
        this.state$.next(this.initialState);
    }
}
